module.exports = __webpack_public_path__ + "static/media/no-tournament.f8aee4c4.png";